
















































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Program from '@/models/Program';
import { getLotsPrescriber, generateProgramReport } from '@/api/api';
import { formatType, formatType2 } from '@/data/types';
import AuthModule from '@/store/AuthModule';
import { BACKEND_URL } from '@/helpers/constants';
import { buildDocumentUrl } from '@/helpers/document';

// Same key already used for the Maps JavaScript API (see public/index.html) — the
// report's map is now rendered server-side via the Static Maps API instead of an
// embedded interactive map, so this key also needs "Maps Static API" enabled.
const GOOGLE_MAPS_API_KEY = 'AIzaSyCED_i4HU1rFyDdlg5k4HVDnIzTY5YOa9w';

@Component({})
export default class ProgramReportModal extends Vue {
    @Prop({ required: true }) program!: Program;

    isGenerating: boolean = false;

    // Secondary color used throughout the report (background stays white).
    // Preloaded with the user's vs-primary and editable before generating.
    reportColor: string = '#697450';

    poiGroups = [
        {
            key: 'transport',
            label: 'Transport',
            colorFr: 'Violets',
            color: '#7c3aed',
            matIcon: 'directions_bus',
            children: [
                { value: 'bus_station', text: 'Bus' },
                { value: 'transit_station', text: 'Tramway' },
                { value: 'subway_station', text: 'Métro' },
            ],
        },
        {
            key: 'ecoles',
            label: 'Écoles',
            colorFr: 'Rouges',
            color: '#ef4444',
            matIcon: 'school',
            children: [
                { value: 'primary_school', text: 'École primaire' },
                { value: 'secondary_school', text: 'Collège / Lycée' },
                { value: 'university', text: 'École supérieure' },
            ],
        },
        {
            key: 'restauration',
            label: 'Restauration',
            colorFr: 'Oranges',
            color: '#f97316',
            matIcon: 'restaurant',
            children: [
                { value: 'restaurant', text: 'Restaurant / Brasserie' },
                { value: 'cafe', text: 'Café / Bar' },
            ],
        },
        {
            key: 'marcheCourses',
            label: 'Marché & Courses',
            colorFr: 'Bleus',
            color: '#3b82f6',
            matIcon: 'shopping_cart',
            children: [
                { value: 'supermarket', text: 'Supermarché' },
            ],
        },
        {
            key: 'sport',
            label: 'Sport',
            colorFr: 'Verts',
            color: '#22c55e',
            matIcon: 'fitness_center',
            children: [
                { value: 'gym', text: 'Salle de sport' },
                { value: 'stadium', text: 'Complex Sportif' },
            ],
        },
        {
            key: 'sante',
            label: 'Santé',
            colorFr: 'Roses',
            color: '#ec4899',
            matIcon: 'local_hospital',
            children: [
                { value: 'hospital', text: 'Hôpital' },
                { value: 'pharmacy', text: 'Pharmacie' },
            ],
        },
    ];

    sections: any = {
        informations: {
            selected: true,
            expanded: false
        },
        presentationVendeur: {
            selected: false
        },
        poi: {
            selected: true,
            expanded: false,
            children: {
                transport: true,
                ecoles: false,
                restauration: false,
                marcheCourses: true,
                sport: false,
                sante: false
            }
        },
        lots: {
            selected: false,
            expanded: false
        },


    };

    programLots: any[] = [];
    lotsLoading: boolean = true;

    formatType = formatType;
    formatType2 = formatType2;

    lotStatusLabels: { [key: string]: string } = {
        'available': 'Disponible',
        'optionné': 'Optionné',
        'booked': 'Réservé',
        'acted': 'Acté'
    };

    // Same palette used for status dots/badges across the app (see ProgramLotsCard.vue).
    lotStatusColors: { [key: string]: string } = {
        available: '#66A756',
        optionned: '#6CA6D9',
        booked: '#F8B170',
        acted: '#E26667'
    };

    get selectedLotsCount() {
        return this.programLots.filter(lot => lot.selected).length;
    }

    get selectedLots() {
        return this.programLots.filter(lot => lot.selected).slice(0, 5);
    }

    get selectedPoiCount() {
        return Object.values(this.sections.poi.children).filter(val => val === true).length;
    }

    get currentUserFirstname() {
        return AuthModule.firstname;
    }

    get currentUserLastname() {
        return AuthModule.lastname;
    }

    get photoImage() {
        return AuthModule.photo;
    }

    get backendUrl() {
        return BACKEND_URL;
    }

    planUrl(plan: any) {
        return buildDocumentUrl(this.backendUrl, plan);
    }

        get currentUserPhone() {
            return AuthModule.mobile || AuthModule.phone || 'N/A';
        }

        get currentUserAddress() {
            if (AuthModule.address) {
                const addr = AuthModule.address;
                const streetParts = [addr.street, addr.street2].filter(Boolean).join(', ');
                return `${streetParts}<br>${addr.postal_code} ${addr.city}`;
            }
            return 'N/A';
        }

        get currentUserCompany() {
            if (AuthModule.company && AuthModule.company.name) {
                return AuthModule.company.name;
            }
            return 'N/A';
        }



    getUserPhotoUrl() {
        const photo = this.photoImage as any;
        if (photo && photo.url && photo.name && photo.extension) {
            return this.backendUrl + photo.url + photo.name + '.' + photo.extension;
        }
        return '';
    }

    getPrimaryImageUrl() {
        const baseUrl = 'https://api.plugimmo.pro';
        const defaultImage = 'uploads/program/123864/image_principale_20251029_022110.jpg';
        
        if (this.program.primary_perspective && this.program.primary_perspective.url) {
            const url = this.program.primary_perspective.url;
            return url.startsWith('http') ? url : `${baseUrl}${url}`;
        }
        
        if (this.program.images && this.program.images[0] && this.program.images[0].url) {
            const url = this.program.images[0].url;
            return url.startsWith('http') ? url : `${baseUrl}${url}`;
        }
        
        return `${baseUrl}/${defaultImage}`;
    }

    getPromoterName() {
        return this.program.promoter && this.program.promoter.name ? this.program.promoter.name : null;
    }

    getPromoterDescription() {
        return this.program.promoter && this.program.promoter.description ? this.program.promoter.description : null;
    }

    getTaxSystem() {
        if (!this.program.tax_system) return null;
        return Array.isArray(this.program.tax_system) ? this.program.tax_system.join(', ') : this.program.tax_system;
    }

    getAddressCity() {
        return this.program.address && this.program.address.city ? this.program.address.city : null;
    }

    getAddressPostalCode() {
        return this.program.address && this.program.address.postal_code ? this.program.address.postal_code : null;
    }

    getAddressStreet() {
        return this.program.address && this.program.address.street ? this.program.address.street : 'N/A';
    }

    formatDeliveryDate(dateString: string | null): string {
        if (!dateString) return 'N/A';
        
        try {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        } catch (e) {
            return 'N/A';
        }
    }

    formatStatus(status: string): string {
        return this.lotStatusLabels[status] || status;
    }

    // CRITICAL: Escape HTML special characters to prevent XSS and JS errors
    escapeHtml(text: string): string {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    async mounted() {
        await this.loadLots();

         // Auto-disable vendor section if no data
        if (!this.hasPromoterDescription) {
            this.sections.presentationVendeur.selected = false;
        }

        if (AuthModule.personal_color) {
            this.reportColor = AuthModule.personal_color;
        }
    }

    // The lots endpoint doesn't support perPage: -1 ("fetch everything") — it must be
    // paged through, same as ProgramLotsCard.vue does. Keeps lotsLoading true (and the
    // generate button disabled) until every page has actually arrived.
    async loadLots() {
        if (!this.program || !this.program.id) {
            this.lotsLoading = false;
            return;
        }

        this.lotsLoading = true;
        try {
            const meta = {
                perPage: 4,
                page: 0,
                total: 0,
                pages: 0,
                search: null,
                orderBy: null,
                orderWay: null,
                filters: {
                    price: null,
                    type: null,
                    type2: null
                }
            };

            let { data } = await getLotsPrescriber(this.program.id, meta);
            let allLots = data.data;
            meta.total = data.meta.total;
            meta.pages = data.meta.pages;
            meta.page = data.meta.page;

            while (meta.page < meta.pages - 1) {
                const nextMeta = { ...meta, page: meta.page + 1 };
                const next = await getLotsPrescriber(this.program.id, nextMeta);
                allLots = [...allLots, ...next.data.data];
                meta.total = next.data.meta.total;
                meta.pages = next.data.meta.pages;
                meta.page = next.data.meta.page;
            }

            this.programLots = allLots.map((lot: any) => ({
                ...lot,
                selected: false,
                includePlan: false
            }));
        } catch (error) {
            console.error('Error loading lots for report:', error);
            // @ts-ignore
            this.$vs.notify({
                color: 'danger',
                title: 'Erreur',
                text: 'Impossible de charger les lots du programme.',
            });
        } finally {
            this.lotsLoading = false;
        }
    }

    toggleSection(sectionName: string) {
        if (this.sections[sectionName].hasOwnProperty('expanded')) {
            const newExpandedState = !this.sections[sectionName].expanded;
            
            if (newExpandedState) {
                if (sectionName === 'poi' && this.sections.lots.expanded) {
                    this.sections.lots.expanded = false;
                } else if (sectionName === 'lots' && this.sections.poi.expanded) {
                    this.sections.poi.expanded = false;
                }
            }
            
            this.sections[sectionName].expanded = newExpandedState;
        }
    }

    updateChildrenSelection(sectionName: string) {
        const section = this.sections[sectionName];
        
        if (sectionName === 'lots') {
            this.programLots.forEach(lot => {
                lot.selected = section.selected;
            });
        } else if (section.children) {
            Object.keys(section.children).forEach(key => {
                section.children[key] = section.selected;
            });
        }
    }

    checkParentSelection(sectionName: string) {
        const section = this.sections[sectionName];
        
        if (sectionName === 'lots') {
            const allSelected = this.programLots.every(lot => lot.selected === true);
            const anySelected = this.programLots.some(lot => lot.selected === true);
            
            if (allSelected) {
                section.selected = true;
            } else if (!anySelected) {
                section.selected = false;
            }
        } else if (sectionName === 'poi' && section.children) {
            const selectedCount = Object.values(section.children).filter(val => val === true).length;
            
            if (selectedCount < 2) {
                // @ts-ignore
                this.$vs.notify({
                    color: 'warning',
                    title: 'Attention',
                    text: 'Vous devez sélectionner au moins 2 catégories de Points d\'intérêt',
                });
                
                const childKeys = Object.keys(section.children);
                for (let i = 0; i < childKeys.length; i++) {
                    if (section.children[childKeys[i]] === false) {
                        section.children[childKeys[i]] = true;
                        break;
                    }
                }
            }
            
            const allSelected = Object.values(section.children).every(val => val === true);
            const anySelected = Object.values(section.children).some(val => val === true);
            
            if (allSelected) {
                section.selected = true;
            } else if (!anySelected) {
                section.selected = false;
            } else {
                section.selected = true;
            }
        } else if (section.children) {
            const allSelected = Object.values(section.children).every(val => val === true);
            const anySelected = Object.values(section.children).some(val => val === true);
            
            if (allSelected) {
                section.selected = true;
            } else if (!anySelected) {
                section.selected = false;
            }
        }
    }

    getDistance(lat1: number, lng1: number, lat2: number, lng2: number): number {
        const R = 6371;
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLng = (lng2 - lng1) * Math.PI / 180;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    async fetchNearbyPlaces(lat: number, lng: number, type: string, radius: number = 5000): Promise<any[]> {
        return new Promise((resolve) => {
            const service = new google.maps.places.PlacesService(document.createElement('div'));
            const request = {
                location: new google.maps.LatLng(lat, lng),
                radius: radius,
                type: type
            };

            service.nearbySearch(request, (results: any, status: any) => {
                if (status === google.maps.places.PlacesServiceStatus.OK && results) {
                    const sortedResults = results
                        .map((place: any) => {
                            const placeLat = place.geometry.location.lat();
                            const placeLng = place.geometry.location.lng();
                            const distance = this.getDistance(lat, lng, placeLat, placeLng);
                            return {
                                name: place.name,
                                lat: placeLat,
                                lng: placeLng,
                                distance: distance
                            };
                        })
                        .sort((a: any, b: any) => a.distance - b.distance)
                        .slice(0, 2);
                    resolve(sortedResults);
                } else {
                    resolve([]);
                }
            });
        });
    }


        get hasPromoterDescription(): boolean {
            const description = this.getPromoterDescription();
            if (description === null || description === '') {
                return false;
            }
            return Boolean(description && description.trim().length > 0);
        }

        get isVendeurSectionDisabled(): boolean {
            return !this.hasPromoterDescription;
        }



            

    async generatePDF() {
        try {
            this.isGenerating = true;

            if (this.lotsLoading) {
                // @ts-ignore
                this.$vs.notify({
                    color: 'warning',
                    title: 'Patientez',
                    text: 'Les lots du programme sont encore en cours de chargement',
                });
                return;
            }

            if (!this.program || !this.program.id) {
                // @ts-ignore
                this.$vs.notify({
                    color: 'danger',
                    title: 'Erreur',
                    text: 'Programme introuvable',
                });
                return;
            }

            const selectedPoiCount = Object.values(this.sections.poi.children).filter(val => val === true).length;
            if (selectedPoiCount < 2) {
                // @ts-ignore
                this.$vs.notify({
                    color: 'warning',
                    title: 'Attention',
                    text: 'Vous devez sélectionner au moins 2 catégories de Points d\'intérêt',
                });
                this.isGenerating = false;
                return;
            }

            const selectedLots = this.programLots
                .filter((lot: any) => lot.selected)
                .slice(0, 5)
                .map((lot: any) => ({ id: lot.id }));

            const includeFirstPage = this.sections.informations.selected;
          
            const promoterDescription = this.getPromoterDescription();
            const hasValidPromoterDescription = promoterDescription !== null && 
                                            promoterDescription !== '' && 
                                            promoterDescription && 
                                            promoterDescription.trim().length > 0;

            const showVendeurContent = this.sections.presentationVendeur.selected && hasValidPromoterDescription;


            const includeLotsPage = selectedLots.length > 0;

            const response = await generateProgramReport(this.program.id, {
                selectedLots: selectedLots,
                sections: this.sections
            });
            
            const data = response.data;

            const resp = await fetch('/pdf/report-template.html', { cache: 'no-store' });
            let htmlTemplate = await resp.text();

            const programData = data.program || this.program;
            
            let promoterName = this.getPromoterName();
            if (data.program && data.program.promoter) {
                promoterName = data.program.promoter;
            }
            const promoterInitial = promoterName ? promoterName.charAt(0).toUpperCase() : 'P';

            const promoterDescriptionValue = promoterDescription || '';

            const baseUrl = 'https://api.plugimmo.pro';
            let primaryImageUrl = this.getPrimaryImageUrl();
            
            if (data.program && data.program.primaryImageUrl) {
                const backendUrl = data.program.primaryImageUrl;
                primaryImageUrl = backendUrl.startsWith('http') ? backendUrl : `${baseUrl}${backendUrl}`;
            }

            let deliveryDate = this.formatDeliveryDate(programData.date_delivery);
            if (data.program && data.program.deliveryDate) {
                deliveryDate = data.program.deliveryDate;
            }

            let addressCity = this.getAddressCity() || 'N/A';
            if (data.program && data.program.address && data.program.address.city) {
                addressCity = data.program.address.city;
            }

            let addressPostalCode = this.getAddressPostalCode() || '';
            if (data.program && data.program.address && data.program.address.postal_code) {
                addressPostalCode = data.program.address.postal_code;
            }

            let addressStreet = this.getAddressStreet();
            if (data.program && data.program.address && data.program.address.street) {
                addressStreet = data.program.address.street;
            }

            let mapLatitude = '48.8566';
            let mapLongitude = '2.3522';
            
            if (data.program && data.program.address) {
                if (data.program.address.latitude) {
                    mapLatitude = String(data.program.address.latitude);
                }
                if (data.program.address.longitude) {
                    mapLongitude = String(data.program.address.longitude);
                }
            }

            const selectedPoiCategories = [];
            for (const group of this.poiGroups) {
                if (this.sections.poi.children[group.key] === true) {
                    const categoryData: any = {
                        key: group.key,
                        label: group.label,
                        colorFr: group.colorFr,
                        color: group.color,
                        matIcon: group.matIcon,
                        children: []
                    };

                    for (const child of group.children) {
                        // A ZERO_RESULTS status from Google (e.g. no subway station
                        // nearby) must never abort the report — we just note the
                        // category as unavailable instead of hiding it or throwing.
                        const places = await this.fetchNearbyPlaces(
                            parseFloat(mapLatitude),
                            parseFloat(mapLongitude),
                            child.value
                        );

                        categoryData.children.push({
                            type: child.value,
                            text: child.text,
                            places: places
                        });
                    }

                    selectedPoiCategories.push(categoryData);
                }
            }

            // The report page is printed from an isolated window that used to embed this
            // data as JSON inside an inline <script> string literal — any place name with
            // an apostrophe (e.g. "Rue de l'Annonciation") broke out of that string and
            // crashed the whole document.write() with a SyntaxError. Building a static map
            // image instead sidesteps that entire class of bug (no data goes into a <script>
            // tag anymore) and also removes the interactive map controls (satellite toggle,
            // zoom buttons, street view) that don't belong in a printed PDF.
            const toStaticMapColor = (hex: string) => '0x' + hex.replace('#', '');
            const markersByColor = new Map<string, string[]>();
            for (const category of selectedPoiCategories) {
                for (const child of category.children) {
                    for (const place of child.places) {
                        const key = category.color;
                        if (!markersByColor.has(key)) markersByColor.set(key, []);
                        markersByColor.get(key)!.push(`${place.lat},${place.lng}`);
                    }
                }
            }

            const STATIC_MAP_STYLES = [
                'feature:all|element:geometry|color:0xf5f5f3',
                'feature:all|element:labels.icon|visibility:off',
                'feature:all|element:labels.text.fill|color:0x6b7280',
                'feature:all|element:labels.text.stroke|color:0xf5f5f3',
                'feature:administrative|element:geometry|color:0xc9c8c3',
                'feature:poi|element:all|visibility:off',
                'feature:road|element:geometry|color:0xffffff',
                'feature:road|element:geometry.stroke|color:0xe0dfda',
                'feature:road.highway|element:geometry|color:0xf0eee8',
                'feature:transit|element:all|visibility:off',
                'feature:water|element:geometry|color:0xd7e3e8',
            ];

            const mapParams = new URLSearchParams();
            mapParams.set('center', `${mapLatitude},${mapLongitude}`);
            mapParams.set('zoom', '15');
            mapParams.set('size', '420x560');
            mapParams.set('scale', '2');
            mapParams.set('maptype', 'roadmap');
            mapParams.set('key', GOOGLE_MAPS_API_KEY);
            STATIC_MAP_STYLES.forEach(style => mapParams.append('style', style));
            mapParams.append('markers', `color:${toStaticMapColor(this.reportColor)}|${mapLatitude},${mapLongitude}`);
            markersByColor.forEach((points, color) => {
                mapParams.append('markers', `color:${toStaticMapColor(color)}|` + points.join('|'));
            });

            const mapImageUrl = `https://maps.googleapis.com/maps/api/staticmap?${mapParams.toString()}`;
            const mapLinkUrl = `https://www.google.com/maps/search/?api=1&query=${mapLatitude},${mapLongitude}`;

            // FIXED: Escape place names in HTML
            // Category icon badges and numbered place chips mirror the colored/numbered
            // markers plotted on the map, so the list and the map read as one system.
            let poiCategoriesHtml = '';
            for (const category of selectedPoiCategories) {
                poiCategoriesHtml += '<div class="poi-category-item">';
                poiCategoriesHtml += '<div class="poi-category-header">';
                poiCategoriesHtml += '<span class="poi-category-icon" style="background:' + category.color + '"><span class="material-icons">' + category.matIcon + '</span></span>';
                poiCategoriesHtml += '<span class="poi-category-label">' + this.escapeHtml(category.label) + '</span>';
                poiCategoriesHtml += '</div>';

                for (const child of category.children) {
                    poiCategoriesHtml += '<div class="poi-child-item">';
                    poiCategoriesHtml += '<div class="poi-child-label">' + this.escapeHtml(child.text) + '</div>';

                    if (child.places.length === 0) {
                        // No result for this POI type nearby (e.g. no subway station) —
                        // say so instead of silently dropping the line or failing the report.
                        poiCategoriesHtml += '<div class="poi-place-line poi-place-unavailable">';
                        poiCategoriesHtml += '<span class="poi-place-name">Non disponible à proximité</span>';
                        poiCategoriesHtml += '</div>';
                    }

                    for (let i = 0; i < child.places.length; i++) {
                        const place = child.places[i];
                        const distanceFormatted = place.distance.toFixed(1).replace('.', ',');
                        poiCategoriesHtml += '<div class="poi-place-line">';
                        poiCategoriesHtml += '<span class="poi-place-num" style="background:' + category.color + '">' + (i + 1) + '</span>';
                        poiCategoriesHtml += '<span class="poi-place-name">' + this.escapeHtml(place.name) + '</span>'; // FIXED: Escape place names
                        poiCategoriesHtml += '<span class="poi-place-distance">' + distanceFormatted + ' km</span>';
                        poiCategoriesHtml += '</div>';
                    }

                    poiCategoriesHtml += '</div>';
                }

                poiCategoriesHtml += '</div>';
            }

            const taxSystemValue = this.getTaxSystem();
            const taxSystemDisplay = taxSystemValue || 'N/A';

            const currentUserName = `${this.currentUserFirstname} ${this.currentUserLastname}`;
            const currentUserPhotoUrl = this.getUserPhotoUrl();
            const userInitial = this.currentUserFirstname ? this.currentUserFirstname.charAt(0).toUpperCase() : 'P';

            let finalHtml = htmlTemplate;

            if (includeFirstPage) {
                finalHtml = finalHtml
                    .replace(/{{ program_description }}/g, programData.description || '')
                    .replace(/{{ tax_system }}/g, taxSystemDisplay)
                    .replace(/{{ address_street }}/g, addressStreet)
                    .replace(/{{ address_city }}/g, addressCity)
                    .replace(/{{ address_postal_code }}/g, addressPostalCode)
                    .replace(/{{ date_delivery }}/g, deliveryDate)
                    .replace(/{{ lowest_price }}/g, programData.lowestPrice || programData.lowest_price ? (programData.lowestPrice || programData.lowest_price).toLocaleString('fr-FR') : 'N/A')
                    .replace(/{{ highest_price }}/g, programData.highestPrice || programData.highest_price ? (programData.highestPrice || programData.highest_price).toLocaleString('fr-FR') : 'N/A')
                    .replace(/{{ average_price_per_square_meter }}/g, (programData.averagePricePerM2 || programData.average_price_per_square_meter) ? (programData.averagePricePerM2 || programData.average_price_per_square_meter).toLocaleString('fr-FR') : 'N/A')
                    .replace(/{{ primary_image_url }}/g, primaryImageUrl);
            } else {
                finalHtml = finalHtml.replace(/<!-- FIRST_PAGE_START -->[\s\S]*?<!-- FIRST_PAGE_END -->/g, '');
            }

            finalHtml = finalHtml
                .replace(/{{ promoter_name }}/g, promoterName || 'N/A')
                .replace(/{{ promoter_initial }}/g, promoterInitial)
                .replace(/{{ program_name }}/g, programData.name || 'N/A')
                .replace(/{{ promoter_description }}/g, promoterDescriptionValue)
                .replace('<!-- POI_CATEGORIES_PLACEHOLDER -->', poiCategoriesHtml)
                .replace(/{{ map_image_url }}/g, mapImageUrl)
                .replace(/{{ map_link_url }}/g, mapLinkUrl)
                .replace(/{{ current_user_name }}/g, currentUserName)
                .replace(/{{ current_user_phone }}/g, this.currentUserPhone)
                .replace(/{{ current_user_address }}/g, this.currentUserAddress)  
                .replace(/{{ current_user_company }}/g, this.currentUserCompany)
                .replace(/{{ current_user_photo }}/g, currentUserPhotoUrl)
                .replace(/{{ user_initial }}/g, userInitial)
                .replace(/{{ primary_color }}/g, this.reportColor);

            if (!showVendeurContent) {
                finalHtml = finalHtml.replace(/<!-- VENDEUR_CONTENT_START -->[\s\S]*?<!-- VENDEUR_CONTENT_END -->/g, '');
            }
            

            const lotsData = data.lots || this.selectedLots;
            
            if (includeLotsPage && lotsData && lotsData.length > 0) {
                let lotsHtml = '';
                
                lotsData.forEach((lot: any) => {
                    const toNumber = (v: any) => {
                        const n = Number(v);
                        return isNaN(n) ? 0 : n;
                    };
                    const fmt2 = (v: any) =>
                        toNumber(v).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    const fmt0 = (v: any) => toNumber(v).toLocaleString('fr-FR');

                    const formattedType = formatType(lot.type);
                    const formattedType2 = formatType2(lot.type2);

                    const surface = toNumber(lot.surface_carrez);
                    const surfaceText = fmt2(surface);

                    const price = toNumber(lot.price);
                    const formattedPrice = fmt0(price);

                    const pricePerSqm = surface > 0 ? price / surface : 0;
                    const pricePerSqmText = fmt2(pricePerSqm);

                    const formattedStatus = this.formatStatus(lot.status);
                    const statusColor = this.lotStatusColors[lot.status] || 'var(--accent)';

                    const buildingInfo = lot.building ? '(' + lot.building + ')' : '';
                    const statusLine = buildingInfo ? (formattedStatus + ' · ' + buildingInfo) : formattedStatus;
                    const lotName = lot.name || '';
                    const floor = lot.floor || 'N/A';
                    const exposure = lot.exposure || 'N/A';

                    let annexesHtml = '';
                    if (lot.annexes && Array.isArray(lot.annexes) && lot.annexes.length > 0) {
                        const annexesList = lot.annexes
                            .map((a: any) => {
                                const aName = a && a.name ? a.name : '';
                                const aType = a && a.type ? a.type : '';
                                const label = (aName || aType) ? [aName, aType].filter(Boolean).join(' – ') : 'Annexe';
                                const hasPrice = a && a.price !== undefined && a.price !== null;
                                const priceTxt = hasPrice ? ' (' + fmt0(a.price) + ' €)' : '';
                                return '<span class="annexe-type">' + label + priceTxt + '</span>';
                            })
                            .join('');
                        annexesHtml =
                            '<div class="annexes-section">' +
                            '<div class="annexes-label">' +
                            '<span class="material-icons">add_circle_outline</span>' +
                            'Annexes' +
                            '</div>' +
                            '<div class="annexes-content">' +
                            '<div class="annexe-types">' +
                            annexesList +
                            '</div>' +
                            '</div>' +
                            '</div>';
                    }

                    let terraceHtml = '';
                    if (lot.surface_terrace && toNumber(lot.surface_terrace) > 0) {
                        terraceHtml =
                            '<div class="lots-info-secondary">' +
                            '<span class="material-icons">deck</span>' +
                            '<span>Terrasse ' + fmt2(lot.surface_terrace) + ' m²</span>' +
                            '</div>';
                    }

                    let tvaHtml = '';
                    if (lot.price_vat_reduce_or_controlled && toNumber(lot.price_vat_reduce_or_controlled) > 0) {
                        tvaHtml = '<div class="lot-price-secondary">TVA 10%: ' +
                            fmt0(lot.price_vat_reduce_or_controlled) + ' €</div>';
                    }

                    let pinelHtml = '';
                    if (lot.rent_limit_pinel && toNumber(lot.rent_limit_pinel) > 0) {
                        pinelHtml =
                            '<div class="lots-financial-item" style="grid-column: span 2;">' +
                            '<span class="material-icons">payments</span>' +
                            '<span class="lots-financial-label">Loyer PINEL</span>' +
                            '<span class="lots-financial-value">' + fmt2(lot.rent_limit_pinel) + ' €</span>' +
                            '</div>';
                    }

                    let profitabilityHtml = '';
                    if (lot.profitability && toNumber(lot.profitability) > 0) {
                        profitabilityHtml =
                            '<div class="lots-financial-item" style="grid-column: span 2;">' +
                            '<span class="material-icons">trending_up</span>' +
                            '<span class="lots-financial-label">Rentabilité</span>' +
                            '<span class="lots-financial-value">' + fmt2(lot.profitability) + '%</span>' +
                            '</div>';
                    }

                    lotsHtml +=
                        '<div class="lot" style="--status-color: ' + statusColor + '">' +
                        '<div class="lot-head">' +
                        '<div class="bubble">' + lotName + '</div>' +
                        '<div class="lot-title-block">' +
                        '<div class="lot-title">' + formattedType + ' – ' + formattedType2 + '</div>' +
                        '<div class="lot-sub"><span class="status-dot"></span>' + statusLine + '</div>' +
                        '</div>' +
                        '<div class="lot-price-block">' +
                        '<div class="lot-price-main">' +
                        '<span class="material-icons">euro</span>' +
                        formattedPrice + ' €' +
                        '</div>' +
                        tvaHtml +
                        '</div>' +
                        '</div>' +

                        '<div class="lot-body">' +
                        '<div class="lots-info-block" style="grid-column: span 2;">' +
                        '<div class="lots-info-row">' +
                        '<span class="material-icons">square_foot</span>' +
                        '<span class="lots-info-label">Surface</span>' +
                        '<span class="lots-info-value">' + surfaceText + ' m²</span>' +
                        '</div>' +
                        terraceHtml +
                        '</div>' +

                        '<div class="lots-info-block" style="grid-column: span 2;">' +
                        '<div class="lots-info-row">' +
                        '<span class="material-icons">stairs</span>' +
                        '<span class="lots-info-label">Étage</span>' +
                        '<span class="lots-info-value">' + floor + '</span>' +
                        '</div>' +
                        '</div>' +

                        '<div class="lots-info-block" style="grid-column: span 2;">' +
                        '<div class="lots-info-row">' +
                        '<span class="material-icons">explore</span>' +
                        '<span class="lots-info-label">Orientation</span>' +
                        '<span class="lots-info-value">' + exposure + '</span>' +
                        '</div>' +
                        '</div>' +

                        pinelHtml +
                        profitabilityHtml +

                        '<div class="lots-financial-item" style="grid-column: span 2;">' +
                        '<span class="material-icons">euro</span>' +
                        '<span class="lots-financial-label">Prix/m²</span>' +
                        '<span class="lots-financial-value">' + pricePerSqmText + ' €</span>' +
                        '</div>' +
                        '</div>' +

                        annexesHtml +
                        '</div>';
                });

                finalHtml = finalHtml
                    .replace(/<!-- LOTS_CONTENT_START -->[\s\S]*?<!-- LOTS_CONTENT_END -->/g, lotsHtml)
                    .replace(/{{ lots_count }}/g, String(lotsData.length));
            } else {
                finalHtml = finalHtml.replace(/<!-- LOTS_PAGE_START -->[\s\S]*?<!-- LOTS_PAGE_END -->/g, '');
            }

            const printWindow = window.open('', '_blank');
            if (printWindow) {
                printWindow.document.write(finalHtml);
                printWindow.document.close();

                // Wait for the report page to signal it's actually ready (all images
                // loaded/failed and the map tiles rendered) before printing, instead of
                // guessing with a fixed delay — this is what was causing PDFs to come
                // out missing the map or the hero image on slower connections.
                await this.waitForReportReady(printWindow);
                printWindow.print();
            }

            // @ts-ignore
            this.$vs.notify({
                color: 'success',
                title: 'Succès',
                text: 'Le rapport a été généré avec succès',
            });

            this.$emit('close');

        } catch (error) {
            console.error('Error generating report:', error);
            // @ts-ignore
            this.$vs.notify({
                color: 'danger',
                title: 'Erreur',
                text: 'Une erreur est survenue lors de la génération du rapport',
            });
        } finally {
            this.isGenerating = false;
        }
    }

    // Resolves once the report window has signalled `report-ready` (dispatched by
    // report-template.html after all its images and the map tiles have loaded),
    // or after a hard timeout so a stuck map/image can't hang PDF generation forever.
    waitForReportReady(printWindow: Window, timeoutMs: number = 8000): Promise<void> {
        return new Promise((resolve) => {
            let settled = false;
            const finish = () => {
                if (settled) return;
                settled = true;
                resolve();
            };

            const checkReady = () => {
                if ((printWindow as any).__reportReady) {
                    finish();
                    return;
                }
                printWindow.addEventListener('report-ready', finish, { once: true });
            };

            if (printWindow.document.readyState === 'complete') {
                checkReady();
            } else {
                printWindow.addEventListener('load', checkReady, { once: true });
            }

            setTimeout(finish, timeoutMs);
        });
    }
}

